import { ManualQuarter, Salutation } from '../../@types/types'

export const convertTrackingParameter = (value: string) =>
  value
    .replace(/([A-Z])/g, '_$1')
    .trim()
    .toLowerCase()

export const convertImageUrl = (width: string, height: string, url?: string): string | undefined => {
  const urlWidth = '%WIDTH%'
  const urlHeight = '%HEIGHT%'

  return url?.replace(urlWidth, width).replace(urlHeight, height)
}

export const convertImageUrlForImageEditor = (url: string, source: string): string => {
  let newUrl = url
  if (source === 'OFFER_API') {
    const indexOfOrig = url.lastIndexOf('/ORIG')
    newUrl = indexOfOrig !== -1 ? url.substring(0, indexOfOrig) + '?cors=1' : url
  }

  return newUrl
}

export const cutToChosenDigitLength = (inputValue: string | undefined, digitLength: number): string | undefined => {
  if (inputValue === undefined) {
    return undefined
  }
  const value: string = inputValue
  if (value.length >= digitLength) {
    return value.slice(0, digitLength)
  }
  return value
}

export const removeExtraWhitespaces = (inputValue: string | number | undefined) => {
  if (inputValue === undefined) {
    return undefined
  }
  return removeExtraWhitespacesWithoutUndefined(inputValue)
}

export const removeExtraWhitespacesWithoutUndefined = (inputValue: string | number) => {
  const value = String(replaceControlCharacters(inputValue))
  return value.replace(/  +/g, ' ').trim()
}

export const sanitizeDistrictName = (name: string): string => {
  if (!name) {
    return ''
  }
  const match = name.match(/^(.+?)\s*\((.+)\)$/)
  if (match && match[1].trim() === match[2].trim()) {
    // Remove duplication pattern: "Name (Name)" → "Name"
    return match[1].trim()
  }
  return name
}

export const convertManualItem = ({ value, label }: ManualQuarter, sanitize: boolean = false) => ({
  id: value ? parseInt(value, 10) : 0,
  name: sanitize && label ? sanitizeDistrictName(label) : label || '',
})

export const getSalutation = (salutation: string) => {
  switch (salutation) {
    case 'MALE':
      return Salutation.MALE
    case 'FEMALE':
      return Salutation.FEMALE
    default:
      return Salutation.NO_SALUTATION
  }
}

export const cutOfLeadingZeros = (value: string | number | undefined) => {
  let result: string | undefined = undefined
  if (value) {
    result = value === '0' ? String(value) : String(value).replace(/^0+/, '')
  }
  return result
}

export const replaceControlCharacters = (str: string | number | undefined) => {
  return str === undefined
    ? undefined
    : String(str).replace(/[\u0000-\u0008\u000B-\u000C\u000E-\u001F\u007F-\u009F]/g, '')
}
